/* eslint-disable max-len */
/**
 * @type {import('@builder.io/sdk/dist/src/builder.class').Component}
 */

export default {
    name: 'Okendo Reviews',
    friendlyName: 'Okendo Reviews',
    image: 'https://cdn.builder.io/api/v1/image/assets%2F69fac0673d2644f0a0a962e1cb3045ef%2Fe3eebe4d302b463faecebea7c646deef', inputs: [
        {
            name: 'widgetType',
            type: 'string',
            enum: ['standard', 'carousel'],
            defaultValue: 'standard',
        },
        {
            name: 'reviewsBy',
            type: 'string',
            defaultValue: 'all',
            enum: ['all', 'group', 'product'],
        },
        {
            name: 'id',
            type: 'string',
            helperText: "Provide a group/product id for the widget.",
            showIf: options => options.get('reviewsBy') !== "all",
        }
    ]
}